import * as loadingState from '@dragonfruit/constants/loadingState';

import { FETCH_MARKETING_BANNER_ERROR } from '../marketingBanner';

export const FETCH_BRAINTREE_CLIENT_TOKEN = 'FETCH_BRAINTREE_CLIENT_TOKEN';
export const FETCH_BRAINTREE_CLIENT_TOKEN_SUCCESS =
  'FETCH_BRAINTREE_CLIENT_TOKEN_SUCCESS';
export const FETCH_BRAINTREE_CLIENT_TOKEN_ERROR =
  'FETCH_BRAINTREE_CLIENT_TOKEN_ERROR';

export const FETCH_PAYMENT_METHOD_TOKEN = 'FETCH_PAYMENT_METHOD_TOKEN';
export const FETCH_PAYMENT_METHOD_TOKEN_SUCCESS =
  'FETCH_PAYMENT_METHOD_TOKEN_SUCCESS';
export const FETCH_PAYMENT_METHOD_TOKEN_ERROR =
  'FETCH_PAYMENT_METHOD_TOKEN_ERROR';

export const RESET_BRAINTREE_TOKENS = 'RESET_BRAINTREE_TOKENS';

export const fetchBraintreeClientToken = () => ({
  type: FETCH_BRAINTREE_CLIENT_TOKEN,
});
export const fetchBraintreeClientTokenSuccess = clientToken => ({
  type: FETCH_BRAINTREE_CLIENT_TOKEN_SUCCESS,
  payload: { clientToken },
});

export const fetchBraintreeClientTokenError = errorCode => ({
  type: FETCH_BRAINTREE_CLIENT_TOKEN_ERROR,
  payload: {
    errorCode,
  },
});

export const fetchPaymentMethodToken = () => ({
  type: FETCH_PAYMENT_METHOD_TOKEN,
});

export const fetchPaymentMethodTokenSuccess = paymentMethodTokens => ({
  type: FETCH_PAYMENT_METHOD_TOKEN_SUCCESS,
  payload: {
    paymentMethodTokens,
  },
});

export const fetchPaymentMethodTokenError = errorCode => ({
  type: FETCH_PAYMENT_METHOD_TOKEN_ERROR,
  payload: {
    errorCode,
  },
});

export const resetBraintreeTokens = () => ({ type: RESET_BRAINTREE_TOKENS });

// reducer
const INIT_STATE = {
  loadingClientToken: loadingState.EMPTY,
  clientToken: '',
  errorCodeClientToken: '',
  loadingPaymentMethods: loadingState.EMPTY,
  paymentMethodTokens: [],
  errorCodePaymentMethods: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BRAINTREE_CLIENT_TOKEN:
      return {
        ...state,
        loadingClientToken: loadingState.LOADING,
      };
    case FETCH_BRAINTREE_CLIENT_TOKEN_SUCCESS:
      return {
        ...state,
        loadingClientToken: loadingState.READY,
        clientToken: action.payload.clientToken,
      };
    case FETCH_MARKETING_BANNER_ERROR:
      return {
        ...state,
        loadingClientToken: loadingState.ERROR,
        errorCodeClientToken: action.payload.errorCode,
      };
    case FETCH_PAYMENT_METHOD_TOKEN:
      return {
        ...state,
        loadingPaymentMethods: loadingState.LOADING,
      };
    case FETCH_PAYMENT_METHOD_TOKEN_SUCCESS:
      return {
        ...state,
        loadingPaymentMethods: loadingState.READY,
        paymentMethodTokens: action.payload.paymentMethodTokens,
      };
    case FETCH_PAYMENT_METHOD_TOKEN_ERROR:
      return {
        ...state,
        loadingPaymentMethods: loadingState.ERROR,
        errorCodePaymentMethods: action.payload.errorCode,
      };
    case RESET_BRAINTREE_TOKENS:
      return {
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export const getBraintreeClientToken = state =>
  state.braintreeSetup.clientToken;
export const getPaymentMethodTokens = state =>
  state.braintreeSetup.paymentMethodTokens;

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/purchase/braintreeSetup.js